// extracted by mini-css-extract-plugin
export default {"parent-scroll-container":"ChatHistory_parent-scroll-container__35G5+","message-container":"ChatHistory_message-container__5m5FG"};